import { TableSpecState } from './types/table';

// numbers
export const BOOST_CYCLE = 10;
export const CORRECT_VALUE_MAX_LENGTH = 10240;
export const FEEDBACK_MAX_LENGTH = 1000;
export const HIGHLIGHT_SOURCE_LIMIT = 10;
export const MAX_TESTCASE_NUMBER = 100;
export const PRELOADED_TEST_CASES_COUNT = 2;
export const PROMPT_WORD_LIMIT = 1000;
export const RECOMMENDED_PUBLISH_TEST_CASE_COUNT = 10;
export const SCOPE_THRESHOLD_WARNING = 25000;

// DOM IDs
export const MODEL_INSTRUCTIONS_ELEMENT_ID = 'field-ai-model-instructions';
export const PUBLISH_ELEMENT_ID = 'field-ai-publish';

// TODO: deprecate hardcoded design UI
export const REVIEW_TEST_CASE_LABEL_WIDTH = '100px';
export const INFO_LABEL_FLEX = `0 0 ${REVIEW_TEST_CASE_LABEL_WIDTH}`;
export const INFO_SPACING = 2;
export const INFO_WIDTH = '75%';
export const MODEL_QUOTA_WIDTH = { width: '50', height: 'filter.height' };

//Default Scope
export const INITIAL_FILTERS = [
  'folder',
  'clause',
  'Contract Type',
  'Effective Date',
];

export const DEFAULT_TABLE_EXTRACTION_SPEC_STATE: TableSpecState = {
  name: '',
  columns: [{ columnType: null, description: '', name: '' }],
  key: '',
};
